import { HttpInterceptorFn } from '@angular/common/http';

const urlBlacklist: string[] = ['assets/mock/alarms-search.schema.json'];

function shouldIntercept(url: string): boolean {
  return !urlBlacklist.includes(url) && url.includes('.json');
}

export const mockInterceptor: HttpInterceptorFn = (req, next) => {
  if (shouldIntercept(req.url)) {
    let mockUrl = req.url.replace('api/', 'assets/');
    if (req.method === 'OPTIONS') {
      mockUrl = mockUrl.replace('.json', '.schema.json');
    }
    return next(req.clone({ url: mockUrl, method: 'GET' }));
  }
  return next(req);
};
